export enum EntityEnum {
    Brazil = 'BRASIL',
    State = 'ESTADO',
    City = 'MUNICIPIO'
}
